import {axiosInstance} from './api';
import type {AdminTunnelCapability} from './adminTunnel';
import type {Paginated} from './types';

export interface CameraDto {
  id: string;
  name: string;
  guid?: string;
  trassir_name?: string;
  type?: string;
  zone?: number;
  active: boolean;
  online: boolean;
  max_x_resolution?: number;
  max_y_resolution?: number;
  admin_tunnel_capability?: AdminTunnelCapability | null;
}

export interface CameraCreatePayload {
  name: string;
  guid: string;
  trassir_name: string;
  type: string;
  zone: number;
  active?: boolean;
  max_x_resolution?: number;
  max_y_resolution?: number;
}

export const listCameras = (pageSize = 1000, zoneId?: string) => {
  const zoneParam = zoneId ? `&zone=${zoneId}` : '';
  return axiosInstance.get<Paginated<CameraDto>>(`/core/api/cameras/?page_size=${pageSize}${zoneParam}`);
};

export const createCamera = (data: CameraCreatePayload) =>
  axiosInstance.post<CameraDto>('/core/api/cameras/', data);

export const updateCamera = (cameraId: number | string, payload: Partial<CameraCreatePayload>) =>
  axiosInstance.patch<CameraDto>(`/core/api/cameras/${cameraId}/`, payload);

export const deleteCamera = (cameraId: number | string) =>
  axiosInstance.delete(`/core/api/cameras/${cameraId}/`);

export const detectCameraResolution = (cameraId: number | string) =>
  axiosInstance.post<CameraDto>(`/core/api/cameras/${cameraId}/detect-resolution/`);
